import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EActionState, IAppointmentCombinedState, IListValue } from 'models';
import { resetState } from 'store/common/slice';
import { initialState } from './state';

const slice = createSlice({
	name: '@@followups/create',
	initialState,
	reducers: {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		INIT_START: (state, action: PayloadAction<{ activityId: string; opportunityId: string; onSuccess: () => PayloadAction<any> }>) => {
			state.init = EActionState.RUNNING;
			state.activityId = action.payload.activityId;
			state.opportunityId = action.payload.opportunityId;
			state.onSuccess = action.payload.onSuccess;
		},
		INIT_COMPLETED: (
			state,
			action: PayloadAction<{
				followUps: IAppointmentCombinedState[];
				inPersonStartTimes: IListValue[];
				phoneStartTimes: IListValue[];
				durations: string[];
				opportunityFollowUpStatus: string;
			}>
		) => {
			state.init = EActionState.COMPLETED;
			state.followUps = action.payload.followUps;
			state.inPersonStartTimes = action.payload.inPersonStartTimes;
			state.phoneStartTimes = action.payload.phoneStartTimes;
			state.durations = action.payload.durations;
			state.opportunityFollowUpStatus = action.payload.opportunityFollowUpStatus;
		},
		INIT_FAILED: state => {
			state.init = EActionState.FAILED;
		},
		INIT_FLUSH: state => {
			resetState(state, initialState);
		},
		CREATE_START: state => {
			state.create = EActionState.RUNNING;
		},
		CREATE_COMPLETED: state => {
			state.create = EActionState.COMPLETED;
		},
		CREATE_FAILED: state => {
			state.create = EActionState.FAILED;
		},
		OPEN_DIALOG: state => {
			state.open = true;
		},
		CLOSE_DIALOG: state => {
			state.open = false;
		},
		SET_TYPE: (state, action: PayloadAction<string>) => {
			state.form.formData.type.newValue = action.payload;
		},
		SET_DATE: (state, action: PayloadAction<string>) => {
			state.form.formData.date.newValue = action.payload;
		},
		SET_TIME: (state, action: PayloadAction<string>) => {
			state.form.formData.time.newValue = action.payload;
		},
		SET_LENGTH: (state, action: PayloadAction<string>) => {
			state.form.formData.length.newValue = action.payload;
		},
		SET_SPECIAL_INSTRUCTIONS: (state, action: PayloadAction<string>) => {
			state.form.formData.specialInstructions.newValue = action.payload;
		},
		RESET_FORM: state => {
			resetState(state.form, initialState.form);
		}
	}
});

export const { reducer } = slice;
export const actionCreator = slice.actions;
